import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { AppEntities } from "src/config/entities";
import { PostingOfGoodsDto } from "../dtos/PostingOfGoodsDto";
import { IPostingOfGoodsModel } from "../models/IPostingOfGoodsModel";
import { PostingOfGoodsProductDto } from "../dtos/PostingOfGoodsProductDto";
import { PostingOfGoodsService } from "src/services/documents/PostingOfGoodsService";

interface IProps {
  documentId?: string;
}

export const useFetchPostingOfGoods = ({ documentId }: IProps) => {
  const [isDocumentLoading, setIsDocumentLoading] = useState(false);
  const [documentDto, setDocumentDto] = useState<PostingOfGoodsDto | null>(null);
  const [documentModel, setDocumentModel] = useState<IPostingOfGoodsModel | null>(null);
  const dataService = AppEntities.PostingOfGoods.getDataService() as PostingOfGoodsService;

  const postDocument = async () => {
    if (!documentId) return;
    await dataService.PostDocument(documentId);
    toast.success("Document posted successfully");
  };

  const cancelDocument = async () => {
    if (!documentId) return;
    await dataService.CancelDocument(documentId);
    toast.success("Document canceled successfully");
  };

  const updateDocument = async (documentModel: IPostingOfGoodsModel) => {
    if (!documentId) return;
    console.log(documentModel);
    const requestDto: PostingOfGoodsDto = { ...documentModel };
    const responseDto = await dataService.Update(requestDto);
    setDocumentDto(responseDto);
    // toast.success("Document updated successfully");
  };

  const fetchDocument = async () => {
    try {
      setIsDocumentLoading(true);

      console.log("documentId", documentId);

      let responseDto: PostingOfGoodsDto | null = null;
      let responseProductDto: PostingOfGoodsProductDto[] = [];

      if (!documentId) {
        responseDto = await dataService.Create({
          documentDate: new Date()
        });
        setDocumentDto(responseDto);
      } else {
        responseDto = await dataService.Get(documentId);
        setDocumentDto(responseDto);
      }

      if (!responseDto) return;

      const newModel: IPostingOfGoodsModel = {
        ...responseDto,
        products: [...responseProductDto]
      };
      setDocumentModel(newModel);
    } catch (e) {
      console.log(e);
    } finally {
      setIsDocumentLoading(false);
    }
  };

  useEffect(() => {
    fetchDocument();
  }, [documentId]);

  return {
    isDocumentLoading,
    documentDto,
    documentModel,
    postDocument,
    cancelDocument,
    updateDocument
  };
};
